import axios from "axios";
import React from "react";
import { nextApiUrl } from "lib/next-api";
import { removeAuthOnInvalidToken } from "services/identity.service";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    console.error("Client Error:", error);
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error("Client Error:", error, errorInfo);

    axios
      .post(nextApiUrl("/log-error"), {
        error: error?.message,
        url: window.location.href,
      })
      .catch((err) => console.error("Failed to log error:", err));
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="w-full flex-col justify-center gap-2 p-2">
          <p>
            We are facing issues in loading data, kindly refresh the page or
          </p>
          <button className="text-primary-900" onClick={() => removeAuthOnInvalidToken()}>Re-login</button>{" "}
        </div>
      );
    }else{
      return this.props.children;
    }
  }
}

export default ErrorBoundary;
